import { useScrollReveal } from '@/hooks/useScrollReveal';
import YouTubeFacade from '@/components/YouTubeFacade';

const LegalThesis = () => {
  const [ref, isVisible] = useScrollReveal();

  return (
    <section
      ref={ref}
      data-testid="legal-thesis-section"
      className={`legal-section section-reveal ${isVisible ? 'visible' : ''}`}
    >
      <div className="legal-content">
        <h2 className="legal-h2" data-testid="legal-thesis-h2">
          The model is temporary. Your context is the asset.
        </h2>

        <div className="legal-passage mt-8">
          <p className="legal-body" data-testid="legal-thesis-p1">
            Models change. Providers change. Pricing and privacy terms change. The tool your practice prefers next year may not exist today.
          </p>
          <p className="legal-body mt-6" data-testid="legal-thesis-p2">
            Your matter context, approved work, checklists, source hierarchy, review standards, and matter history do not change. They are what your practice is actually made of.
          </p>
          <p className="legal-body mt-6" data-testid="legal-thesis-p3">
            Soundboard Matter keeps that separate from whichever model assists with it, in a portable, human-readable structure you control. The model assists the practice. The practice does not become dependent on the model.
          </p>
        </div>
      </div>

      <div className="legal-content-wide mt-14">
        <YouTubeFacade
          videoId="CBa_K8N66A4"
          heading="Own the context. Rent the model."
          caption="Vino, founder of Soundboard.space, on why the durable asset is the knowledge and not the tool."
          title="Own the context. Rent the model."
        />
      </div>
    </section>
  );
};

export default LegalThesis;
